<div class="recipient-panel">
    <div class="recipient-header" *ngIf="title">{{ title }}</div>
    <nz-spin [nzSpinning]="showLoading ? loading : false">
        <div class="user-filter">
            <nz-input-group [nzSuffix]="filter.keyword ? inputClearTpl : suffixIconSearch" class="select-style">
                <input type="text" nz-input [(ngModel)]="filter.keyword" (keydown)="enterSearch($event)" (ngModelChange)="onKeywordChange()"
                       placeholder="Search..." />
            </nz-input-group>
            <ng-template #suffixIconSearch>
                <em nz-icon nzType="search" (click)="onSearch()" *ngIf="!filter.keyword"></em>
            </ng-template>
            <ng-template #inputClearTpl>
                <em
                        nz-icon
                        class="ant-input-clear-icon"
                        nzTheme="fill"
                        nzType="close-circle"
                        *ngIf="filter.keyword"
                        (click)="clearKeyword()"
                ></em>
            </ng-template>
        </div>
        <app-st
            #st
            class="select-user"
            [columns]="columns"
            [data]="fliterRecipientList"
            [page]="{show: false}"
            [selectType]="'multiple'"
            [canSelect]="true"
            size="small"
            rowKey="email"
            [scroll]="{ y: '200px' }"
            [checkIds]="selectUserEmails !== null ? selectUserEmails : []"
            (selectChange)="handleSelect($event)"
        >
        </app-st>

        <form nz-form [formGroup]="validateForm" class="recipient-form" [nzAutoTips]="autoTips">
            <nz-form-item class="form-item" *ngFor="let control of listOfControl; let i = index;">
                <nz-form-control>
                    <input [formControlName]="control.email" nz-input placeholder="Please enter email" trim="blur"/>
                </nz-form-control>
                <div class="remove-btn">
                    <i nz-icon nzType="minus-circle-o" class="dynamic-delete-button" (click)="removeField(control, $event)"></i>
                </div>
            </nz-form-item>
            <nz-form-item *ngIf="listOfControl.length < 20" class="btn-row">
                <button nz-button nzType="primary" class="add-btn" (click)="addField()">
                    <i nz-icon nzType="plus"></i>
                    Add Custom Recipient
                </button>
            </nz-form-item>
        </form>
    </nz-spin>
</div>
